import { Injectable } from '@angular/core';
import { GlobalVariable } from '.././config/service.config';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Contact } from '../models/contact.model';

@Injectable({
  providedIn: 'root'
})
export class ContactService {
  url = GlobalVariable.BASE_API_URL;
  token = `Bearer ${JSON.parse(localStorage.getItem('token'))}`;
  headersc = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Accept', 'application/json');

  headers = new HttpHeaders({
    'Content-Type': 'application/json',
    Authorization: this.token.replace(/["']/g, '')
  });
  constructor(private http: HttpClient) { }
  //Registrar
  public SendPersona(persona: any) {
    return this.http.post(`${this.url}Contact/Create`, persona, { headers: this.headersc });
  }
  public ValidarRUTPasaporte(rut: string, nacionalidad: string) {
    return this.http.post(`${this.url}Contact/Validar/?rut=${rut}&&nacionalidad=${nacionalidad}`, null, { headers: this.headersc });
  }
  public ValidaExisteCorreo(correo: string) {
    return this.http.post(`${this.url}Contact/ExisteCorreo/?correo=${correo}`, null, { headers: this.headersc });
  }

  public GetContactFull(idcontacto: string, idproceso: string) {
    return this.http.post(`${this.url}Contact/GetUser?idAcceso=${idcontacto}&idproceso=${idproceso}`, null, { headers: this.headersc });
  }
  public GetInfoApoderado(idProceso: string) {
    return this.http.post(`${this.url}ProcesoMatricula/getInfoApoderado?idProceso=${idProceso}`, null, { headers: this.headers });
  }
  public UpdateContact(contacto: Contact) {
    return this.http.post(`${this.url}Contact/setUser`, JSON.stringify(contacto), { headers: this.headersc });
  }

  public ExistePostulacionRut(rut: string, dv: string, esPasaporte: boolean = false) {
    let httpParams = new HttpParams()
      .set('rut', rut)
      .set('dv', dv)
      .set('esPasaporte', String(esPasaporte))
    return this.http.post(`${this.url}Contact/ExistePostulacionRut`,
      null,
      {
        headers: this.headersc,
        params: httpParams
      });
  }

  public ExistePostulacionEs24(rut: string, dv: string) {
    let httpParams = new HttpParams()
      .set('rut', rut)
      .set('dv', dv)
    return this.http.post(`${this.url}Contact/ExistePostulacionEs24`,
      null,
      {
        headers: this.headersc,
        params: httpParams
      });
  }
}
